import { useQuery } from '@tanstack/react-query';

import { GetCurrentUserPermissions } from '../../../http/CompanyUserManagement/userManagementApi';
import queryKeys from './queryKeys';

const useUserPermissions = () => {
  const query = useQuery({
    queryKey: [queryKeys.userPermissions],
    queryFn: async () => await GetCurrentUserPermissions(),
    staleTime: 300000
  });

  return query;
};

export default useUserPermissions;
